module.exports = __webpack_public_path__ + "static/media/bootstrap.3f48d53d.png";